import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Button from '@minecraft.button';
import Icon from '@minecraft.icon';

export const ButtonContainer = styled.div`
  background: ${(props): string => props.theme.colors.accent.greyBlue2};
  padding: 1rem;
  margin: 1rem 0;
  &:first-child {
    margin-top: 1.6rem;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const StyledUserInfo = styled.div`
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  padding-bottom: 0.7rem;
  line-height: 1.2rem;
  padding-top: 0.7rem;
  &:first-child {
    margin-top: 0.7rem;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledIcon = styled(Icon)`
  margin-left: 0.25rem;
  fill: ${(props): string => props.theme.colors.primary.primary};
`;

export const InfoRowItems = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  ${media.sm`
    flex-direction: row;
  `}
`;

export const StyledRole = styled.div`
  display: block;
  margin-bottom: 0.625rem;
  ${media.sm`
    display: inline;
    margin-bottom: 0;
  `}
`;

export const CommaSpan = styled.span`
  display: none;
  margin-right: 0.25rem;
  ${media.sm`
    display: inline;
  `}
`;

export const InfoHead = styled.h4`
  margin: 0 0 0.5rem;
  font-weight: 600;
  font-size: 1rem;
`;
